var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",style:(_vm.homeStyle)},[_c('router-view'),_vm._l((_vm.homeData),function(item,index){return _c(item.type,{key:index,tag:"component",attrs:{"comObj":item.data}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }